<section [formGroup]="personal_info">

  <ng-container formGroupName="mobile_numbers">
    <mat-form-field>
      <input matInput required formControlName="0" placeholder="Mobile number"/>
      <mat-error *ngIf="personal_info.get('mobile_numbers.0').hasError('invalid')">
        {{personal_info.get('mobile_numbers.0').getError('invalid')}}
      </mat-error>
      <mat-error *ngIf="personal_info.get('mobile_numbers.0').hasError('required')">Required.
      </mat-error>
    </mat-form-field>
  </ng-container>

  <ng-container required formGroupName="email_addresses">
    <mat-form-field>
      <input matInput required formControlName="0" placeholder="Email"/>
      <mat-error *ngIf="personal_info.get('email_addresses.0').hasError('invalid')">
        {{personal_info.get('email_addresses.0').getError('invalid')}}
      </mat-error>
      <mat-error *ngIf="personal_info.get('email_addresses.0').hasError('required')">Required.</mat-error>
    </mat-form-field>
  </ng-container>

</section>
